module.exports = __webpack_public_path__ + "static/media/img03.4a0f73f2.jpg";